import { useEffect, useMemo, useState } from "react"
import { Link } from "react-router-dom"
import { Input, Button, Table, Space, Switch, Popconfirm, DatePicker } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import _ from 'lodash'

const { Column } = Table
const { RangePicker } = DatePicker

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

type fetchParams = {
    template_name: string | undefined
    date: any
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        template_name: undefined,
        date: null
    }

    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [data, setData] = useState<any>([])

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        if (params.date) {
            params.update_time_start_day = params.date[0].format('YYYY-MM-DD')
            params.update_time_end_day = params.date[1].format('YYYY-MM-DD')
            delete params.date
        }

        axiosTable.get('/cooking_center/menu_template/page_list', {
            params: {
                ...iPagination,
                ...params
            }
        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    return (<div className="common-page">
        {/* 膳食中心 -> 营养膳食 -> 标准餐单管理 */}
        <BreadCrumb position={['膳食中心', '标准餐单管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="餐单名称" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'template_name') }} value={fetchOtherParams.template_name} />
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} placeholder={["更新开始日期", "更新结束日期"]} value={fetchOtherParams.date} onChange={(v: any) => { handleChange(v, 'date') }} />
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch} >查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('添加') && <Button type="primary" ><Link to={"/menu_template_add"}>添加</Link></Button>}
            </div>
        </div>

        <div className="common-main">
            <Table dataSource={data} bordered={true} rowKey="template_id" pagination={pagination} onChange={handleTableChange}>
                <Column title="餐单名称" dataIndex="template_name" key="template_name" />
                <Column title="包含阶段" dataIndex="stage_count" key="stage_count" />
                <Column title="已配天数" dataIndex="day_count" key="day_count" />
                <Column title="高价菜品数量" dataIndex="high_price_item_count" key="high_price_item_count" />

                {permission.includes('是否启用') && <Column title="是否启用" render={(v: any) => {
                    return <Switch checked={v.is_use == 0 ? false : true} onChange={(status: boolean) => {
                        baseAxiosNoInfo.post('/cooking_center/menu_template/use_switch', {
                            template_id: v.template_id,
                            is_use: status ? 1 : 0
                        }).then(res => {
                            fetch({ pagination, fetchOtherParams })
                        })
                    }} />
                }} />}

                <Column title="更新时间" dataIndex="update_time" key="update_time" />
                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => (
                        <Space size="middle">
                            {permission.includes('编辑') && <Button size="small" type="primary" >
                                <Link to={"/menu_template_edit/" + record.template_id}>编辑</Link>
                            </Button>}

                            {permission.includes('删除') && <Popconfirm
                                title="确定删除?"
                                onConfirm={() => {
                                    baseAxiosComplete.post('/cooking_center/menu_template/delete', {
                                        id: record.template_id
                                    }).then(res => {
                                        if (res.status === 0) {
                                            resetForm()
                                        }
                                    })
                                }}
                                okText="是"
                                cancelText="否"
                            >
                                <Button size="small">删除</Button>
                            </Popconfirm>}
                        </Space>
                    )}
                />
            </Table>
        </div>
    </div>)
}